/**
 * All feature flags consumed by either MPAC or Emcee.
 *
 * Note:
 * - Since MPAC & Emcee flags are managed by separate LaunchDarkly accounts, their flags will be
 * mutually exclusive, and default values for the flags from the other account will be populated
 * respectively. Eventually, the plan is to manage flags from the same account.
 * - IMPORTANT: The flag name/key from LaunchDarkly will be transformed using lodash camelCase
 * utility, if you do not see your flag value being populated correctly, cross-check if the
 * camelCase-ed name is used.
 *
 * @example enableMPACServerEOL -> enableMpacServerEol
 */

/**
 * Default values for each of the feature flags from `MarketplaceFeatureFlags`.
 */
export const DEFAULT_MARKETPLACE_FEATURE_FLAGS = {
  replaceCategoriesOnAppTilesWithVendorName: false,
  hideInstallDownloadCountsEnabled: false,
  showAppRequestPlaceholder: false,
  sortingLogicForCategoryFilter: 'default',
  enableRequestAppCtaCopyChange: false,
  enableBugBountyProgram: false,
  enableTrialExpiryBanner: false,
  enableCloudFortifiedAppsDiscovery: false,
  enableWebpImage: false,
  showCustomBackendErrorsFromUpm: false,
  enableFreeStarterTierFilter: false,
  disableAppInstall: false,
  showManageAppRequestAlternativeLayout: false,
  spaRoutingForPartnerApps: false,
  spaRoutingForPartnerDetails: false,
  spaRoutingForPartnerPayment: false,
  disableAllHostingFromPromotionsDropdown: false,
  spaRoutingForPartnerReports: false,
  reviewsCompliancePrompt: false,
  displayAuditTabInManagePartnerPage: true,
  useAmktFrontendAthreosManagePartners: false,
  enableUpdateByCatalogServiceCall: false,
  enableInContextAppRequest: false,
  showCompatibleSiteProducts: false,
  enableInProductHelpPartnerReporting: false,
  showTrelloProductFilter: false,
  strideHipchatBanners: false,
  showTrustSignalsInManageAppRequests: false,
  showDatePickerOnManagePricingTab: false,
  enableLogAccessByDefaultMessage: false,
  showBenchmarkingUiDropdown: false,
  showDecomposedReviews: false,
  showQualtricsSurvey: false,
  enableRetryForLicenseDetailsPostInstallation: false,
  enableEmailSubscription: false,
  allowSectionMessageForPartnersForMigrationToCcp: [],
  enableIncludePartnerForAllowSectionMessageForMigrationToCcp: false,
  showAppListingTrustTab: false,
  displayPrivacyAndSecurityPreviewTab: false,
  enableReactivateForgeAppFromEmcee: false,
  enableReactivateForgeAppFromEmceeForHAMS: false,
  enableGoogleAnalytics4Tracking: false,
  enableUserSessionAuthForMpacToEmceeRedirect: false,
  enableNewPartnerContactRole: false,
  showCopyChangesForPartnerContact: false,
  enableDualLicenseToggleInPartnersTable: false,
  enableCloudMigrationToggle: false,
  enableReviewComplianceUi: false,
  enablePrefixCodeSectionForGenericCloudPromotions: false,
  enablePromoCodeUniquenessCheck: false,
  enableBacRedirectionForCcpPromotions: false,
  allowSectionMessageForCCPPromotionMigration: false,
  enableMpacServerEolWarning: false,
  enableJsdToJsm: false,
  enableReportsV2FeedbackCollector: false,
  enableReportsAccessibilityChanges: false,
  showPricingAnnouncementAlert: false,
  enableFiftyKTiersForAllApps: false,
  enableFiftyKPricingTiers: false,
  enableForgeEgressAddressesOnInstallScreen: false,
  enableHostingSelectionModal: true,
  showAlternativeRatingsComponent: false,
  pollIntervalForConnectApps: 300,
  enableStaffPickOnAppListing: false,
  serverEolAppsWithDcVersion: [],
  showAppSlugInAppListingUrl: false,
  showAiAppsCollectionTile: false,
  useAnalyticsWebClient: false,
  showRatingsByHostingType: false,
  polyBlackoutDisable: false,
  enableServerEolWarningForBambooAndCrowd: false
};